"use client";
import{useCMP as t}from"./cmp/useCMP.js";const n=({consentState:n,country:o,isGDPRNation:s})=>(t({consentState:n,country:o,isGDPRNation:s}),null);export{n as ConsentProviderClient};
